import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../providers/AuthProvider';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, isLoading, user } = useAuth();
  const location = useLocation();

  // Показываем загрузку пока проверяем аутентификацию
  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600 mx-auto"></div>
          <p className="mt-4 text-gray-600">Загрузка...</p>
        </div>
      </div>
    );
  }

  // Если не аутентифицирован, перенаправляем на публичную главную.
  if (!isAuthenticated) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  // Мягкая обязаловка: если логин выглядит как email, но не подтверждён — перекидываем в настройки профиля
  try {
    const uname = user?.username || '';
    const looksLikeEmail = /.+@.+\..+/.test(uname);
    const verified = !!(user?.email_verified);
    if (looksLikeEmail && !verified && location.pathname !== '/settings') {
      return <Navigate to="/settings" replace />;
    }
  } catch {}

  // Если аутентифицирован, показываем защищенный контент
  return children;
};

export default ProtectedRoute;
